import { takeLatest } from 'redux-saga/effects';
import { FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC } from '../../redux/modules/patientPortalEncounterSync/patientPortalEncounterSync-actions';
import fetchPatientPortalEncounterSyncWorker from './patientPortalEncounterSyncWorkerSaga';

function* fetchPatientPortalEncounterSyncWatcher() {
    yield takeLatest(FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC, fetchPatientPortalEncounterSyncWorker);
}

export default fetchPatientPortalEncounterSyncWatcher;
